import { Button, Modal } from "antd";
import React from "react";
import dialogClose from "static/images/dialog-close.png";

interface IProps {
    title: string;
    open: boolean;
    body: Element[] | Element | string | undefined;
    onClose: Function
    actions?: Element[];
}

const Dialog = ({ open, title, body, actions, onClose }: IProps) => {

    const ModalFooter = ({ ...children }) => {
        if (actions?.length)
            return (
                <div className="dialog-box-footer-actions">
                    {...actions}
                </div>)
        else
            return (
                <div className="dialog-box-footer-actions">
                    <Button type="default" onClick={onClose}>Close</Button>
                </div>
            )
    }

    const Icon = () => {
        return <div className="dialog-close-icon"><img src={dialogClose} alt="dialog-box" /></div>
    }

    return (
        <Modal title={title} visible={open} onCancel={onClose} footer={<ModalFooter />} closeIcon={<Icon />}>{body}</Modal>
    );
}

export default Dialog;